TS.ns('WL'); 

WL.partnerViewModel = new Class({
    Extends: TS.domain.EditDomain,

    initialize: function (config) {
        var me = this;

        me.parent(config);

        var reportList = me.getDomainProperty('dgReportsOnEntity_Property');
        if (reportList != null) {
            reportList.un('cellBeginEdit', me.onReportGridBeginEdit);
            reportList.on('cellBeginEdit', me.onReportGridBeginEdit);
        }
    }, 

    createProperties: function (config) {
        var me = this;

        me.parent(config);

        me.canEditPartnerProperties = ko.computed(function () {
            if (me.CanEditPartnerProperties())
                return true;
            return false;
        });

        var addressList = me.getDomainProperty('dgPartnerAddress_Property');
        var contactList = me.getDomainProperty('dgContactInfoCollection_Property');
        var propertyList = me.getDomainProperty('PropertyList');
        var accountList = me.getDomainProperty('grdBankAccountCollection_Property');
        var activityList = me.getDomainProperty('grdPartnerActivityFieldCollection_Property');
        var shareholderList = me.getDomainProperty('grdPartnerShareholders_Property');
        var partnerTypeIdList = me.getDomainProperty('lkpPartnerTypeId_Property');

        if (addressList) {
            addressList.on('afterAdd', me.onAddressAdded);
            addressList.on('cellValueChanged', me.onAddressChanged, me);
            addressList.on('afterDelete', me.onAddressDeleted); 
        }

        if (propertyList) {
            propertyList.on('addNew', me.onPropertyAdded);
            propertyList.on('cellValueChanged', me.onPropertyChanged, me);
            propertyList.on('cellBeginEdit', me.onPropertyBeginEdit);

            cat = propertyList.Commands;

            cmd = new TS.domain.Command();
            cmd['Code'] = 'ViewPropertyHistory';
            cmd['Text'] = me.ViewPartnerPropertyHistory;
            cmd['handler'] = '_viewPropertyHistory';
            cmd['IconCode'] = 'file';

            cat.push(cmd);

            $.each(propertyList.Commands(), function (index, item) {
                if (item.Code == "Delete")
                    item.InternalVisible = me.canEditPartnerProperties;

                if (item.Code == "Add")
                    item.InternalVisible = me.canEditPartnerProperties;
            });
        }

        // TODO: Disable fields after Person selection.
        if (contactList) {
            contactList.on('addNew', me.onContactAdded);
            contactList.getFieldByName('gcPerson_Field').allowInput = false;
            contactList.getFieldByName('gcPerson_Field').on('propertyChanged', me.onContactChanged, me);
        }

        if (accountList) {
            accountList.on('addNew', me.onAccountAdded);
            accountList.getFieldByName('gcBank_Field').allowInput = false;
            accountList.on('afterAdd', me.onAccountAdded);
        }

        if (activityList) {
            activityList.getFieldByName('gcCAEN_Field').allowInput = false;
            activityList.getFieldByName('gcCAEN_Field').on('propertyChanged', me.onActivityChanged, me);
        }

        if (shareholderList) {
            shareholderList.on('afterAdd', me.onShareholderAdded);
            shareholderList.getFieldByName('gcUniqueID_Field').allowInput = false;
            shareholderList.getFieldByName('gcUniqueID_Field').on('propertyChanged', me.onShareholderChanged, me);

            
            
            $.each(shareholderList.Commands(), function (index, item) {                                       
                if (item.Code == "Add" || item.Code == "Delete")
                    item.InternalVisible = me.CanEditShareholders;
            });

            shareholderList.on('cellBeginEdit', me.onShareholdersGridBeginEdit);
            shareholderList.on('cellValueChanged', me.onShareholderCellValueChanged, me);
        }

        if (partnerTypeIdList != null) {
            partnerTypeIdList.on('selectionChanged', me.onPartnerTypeChanged, me);
            partnerTypeIdList.autoSelect = true;
        }

        var fileUploadProp = me.getDomainProperty('uploadIdentityInfo_Property');
        if (fileUploadProp != null)
            fileUploadProp.on('finished', me._onUploadFinished.bind(me));
    },

    _onUploadFinished: function (e) {
        var me = this;
         
        //owner.Document.FreeTxt(me.fileName());
        me.performServerCommand("Dummy", false);
    },

    onPropertyBeginEdit: function (e) {
        var me = this,
            owner = me._getOwner(),
            val = e.newValue;
        
        me.canEditPartnerProperties = ko.computed(function () {
            if (owner.CanEditPartnerProperties())
                return true;
            return false;
        });

        if (me.canEditPartnerProperties() == false) {
                e.preventDefault();
            }
    },

    onAddressAdded: function (e) {
        var me = this,
            rec = e.item,
            owner = me._getOwner();

        rec.IsActive = 1;
        rec.CountryId(owner.DefaultCountryId());
        rec.CountryName(owner.DefaultCountryName()); 
    },

    onAccountAdded: function (e) {
        var me = this,
            rec = e.item,
            owner = me._getOwner();

        owner.performServerCommand({
            cmd: 'AddAccount',
            submitModel: true,
            blockUI: true
        })
    },

    onAddressChanged: function (e) {
        var me = this,
           rec = e.item;

        if (e.fieldName === 'PostalCode') {
            addressList = me.getDomainProperty('dgPartnerAddress_Property');

            setTimeout(function () {
                me.performServerCommand({
                    cmd: 'LoadPostalCodeInfo',
                    submitModel: true,
                    extraData: { PostalCode: e.newValue, rowIdx: e.rowIdx },
                    blockUI: true
                });
            }, 0)
        }

        if (e.fieldName === 'CityId') {
            addressList = me.getDomainProperty('dgPartnerAddress_Property');

            setTimeout(function () {
                me.performServerCommand({
                    cmd: 'LoadCityInfo',
                    submitModel: true,
                    extraData: { CityId: e.newValue, rowIdx: e.rowIdx },
                    blockUI: true
                });
            }, 0)
        }
    },

    onPartnerTypeChanged: function (e) {
        var me = this;

        me.performServerCommand({
            cmd: 'GetDefaultScoringGridForPartnerType',
            submitModel: true,
            blockUI: true
        });
    },

    onAddressDeleted: function (e) {
        var me = this,
            owner = me._getOwner();
        owner.performServerCommand({
            cmd: 'RefreshAddressList',
            submitModel: true,
            blockUI: true
        })
    },

    onContactAdded: function (e) {
        var me = this,
            rec = e.item,
            owner = me._getOwner();

        owner.performServerCommand({
            cmd: 'AddContact',
            submitModel: true,
            blockUI: true
        })
    },

    onContactChanged: function (selectedRecord) {
        var me = this,
        contactList = me.getDomainProperty('dgContactInfoCollection_Property');

        setTimeout(function () {
            me.performServerCommand({
                cmd: 'LoadContactInfo',
                submitModel: true,
                extraData: { PersonId: selectedRecord.sender.SelectedItem().PersonId, UID: contactList.SelectedItem().UID },
                blockUI: true
            });
        }, 0)
    },

    onPropertyAdded: function (e) {
        var me = this,
          rec = e.item;

        rec.PropertyTypeCode = new ko.observable('Text');
        rec.EditorName = new ko.observable('Text');
        rec.EditorType = new ko.observable('Text');
    },

    onPropertyChanged: function (e) {
        var me = this,
          rec = e.item;

        if (e.fieldName === 'PropertyId') {
            me.performServerCommand({
                cmd: 'RefreshProperty',
                submitModel: true,
                extraData: {
                    NewValue: e.newValue,
                    rowIdx: e.rowIdx
                },
                blockUI: true
            });
        }
        else {
            me.performServerCommand({
                cmd: 'AddPropertyHistory',
                submitModel: true,
                extraData: {
                    PropertyId: e.record.PropertyId(),
                    OldValue: e.oldValue,
                    NewValue: e.newValue,
                },
                blockUI: true
            });
        }


    },

    onActivityChanged: function (selectedRecord) {
        var me = this,
            activityFieldList = me.getDomainProperty('grdPartnerActivityFieldCollection_Property')

        if (selectedRecord.sender.SelectedItem())
            activityFieldList.SelectedItem().ActivityFieldName(selectedRecord.sender.SelectedItem().DictionaryItemName);
    },

    onShareholderChanged: function (selectedRecord) {
        var me = this,
            shareHolderList = me.getDomainProperty('grdPartnerShareholders_Property');

        if (selectedRecord.sender.SelectedItem()) {
            shareHolderList.SelectedItem().ShareholderPartnerName(selectedRecord.sender.SelectedItem().PartnerName);
            shareHolderList.SelectedItem().NationalityId(selectedRecord.sender.SelectedItem().NationalityId);
            shareHolderList.SelectedItem().NationalityName(selectedRecord.sender.SelectedItem().NationalityName);
            shareHolderList.SelectedItem().PartnerTypeId(selectedRecord.sender.SelectedItem().partnerTypeId);
            shareHolderList.SelectedItem().PartnerTypeName(selectedRecord.sender.SelectedItem().PartnerTypeName);
            shareHolderList.SelectedItem().BirthDate(selectedRecord.sender.SelectedItem().BirthDate);

            selectedRecord
        }
    }, 

    onShareholderCellValueChanged: function (e) {
        var me = this,
            rec = e.item;

        if (e.fieldName === 'UniqueID' && e.sender.SelectedItem().ShareholderPartnerId() == null) {
            me.performServerCommand({
                cmd: 'LoadShareholderByUniqueId',
                submitModel: true,
                extraData: {
                    UniqueID: e.newValue,
                    rowIdx: e.rowIdx
                },
                blockUI: true
            });
        }
    },

    onShareholderAdded: function (e) {
        var me = this,
            rec = e.item,
            owner = me._getOwner();

        rec.IsActive = 1;
        rec.NationalityId(owner.DefaultNationalityId());
        rec.NationalityName(owner.DefaultNationalityName());
    },

    onShareholdersGridBeginEdit: function (e) {
        var me = this,
            owner = me._getOwner();

        if (!owner.CanEditShareholders()) {
            e.preventDefault();
        }
        if (e.sender.SelectedItem().ShareholderPartnerId() != null && (e.fieldName == 'PartnerTypeId' || e.fieldName == 'ShareholderPartnerName' || e.fieldName == 'UniqueID' || e.fieldName == 'BirthDate'))
        {
            e.preventDefault();
        }
    },

    _viewPropertyHistory: function () {
        var me = this;

        if (me.Document.PartnerId() == null) return;

        me.performServerCommand({
            cmd: 'ViewPropertyHistory',
            submitModel: true,
            blockUI: false
        });
    },

    _createCommands: function () {
        var me = this,
            cat;

        me.parent();

        cat = me.CommandCategories.Navigation.commands;

        if (cat != null)
            for (var i = 0; i < cat.length; i++) {
                if (cat[i].Code == "AddPartner") cat[i].handler = '_addPartner';
                if (cat[i].Code == "Reports") {
                    for (var j = 0; j < cat[i].commands.length; j++) {
                        cat[i].commands[j].handler = "_showReport";
                    }
                }
            }
    },

    _addPartner: function () {
        var me = this,
            vm,
            url = '../selectPartnerTypeNew/Edit?';

        me.performServerCommand('Dummy', true, null, null, false, true);

        params = {
            popup: true
        }
        url += $.param(params);

        TS.UI.showDomain({
            url: url,
            viewModel: vm,
            popupWidth: 400,
            popupHeight: 200
        }, function (model) {
            model.on("save", function () {
                var me = this,
                    vm,
                    url = '../legalPartner/Add?';

                if (me.PartnerTypeIdValue() === 0)
                    return;

                if (me.PartnerTypeIsPF() === true)
                    url = '../partner/Add?';

                params = {
                    popup: true,
                    hideAddCommand: true,
                    partnerTypeId: me.PartnerTypeIdValue
                }
                url += $.param(params);

                TS.UI.showDomain({
                    url: url,
                    viewModel: vm,
                    popupWidth: window.innerWidth * 8 / 10,
                    popupHeight: window.innerHeight * 8 / 10
                }, function (model) {
                    model.on("close", function () {
                    });
                });
            });
            model.on("close", function () {
            });
        });
    },

    _showReport: function (e) {
        var me = this;
        me.performServerCommand('Navigation.Reports.' + e.Code, true, null,
            function (r) {
                var me = this;

                if (r.modelData == undefined)
                    return;

                if (!r.modelData.ReportExportIsHtml)
                    return;

                var url = me.rootUrl + '/../Handlers/GetReport.ashx' + "?ReportId=" + r.modelData.ReportExportId + r.modelData.ReportExportParameters;
                window.open(url, '_blank');
            });
    },

    onReportGridBeginEdit: function (e) {
        var me = this,
            owner = me._getOwner();

        e.Code = 'Report' + e.record.ReportId();
        owner._showReport(e);
    }
});